<iwt-estatecloud-main-layout>
  <div>
    <iwt-estatecloud-migration-header />
    @if (selectedDbName) {
    <iwt-estatecloud-migration-customer-header
      (unselectedDbNameEvent)="removeSelectedDbName()"
      [dbName]="selectedDbName"
    />
    <iwt-estatecloud-migration-customer-details [dbName]="selectedDbName" />
    } @else {
    <iwt-estatecloud-migration-list-customer
      (selectedDbNameEvent)="addSelectedDbName($event)"
    />
    }
  </div>
</iwt-estatecloud-main-layout>
